import Title from "../common/Title";
import BookYourFlightsImage from "../../assets/img/book-your-tickets-img.webp";
import PrimaryBtn from "../common/PrimaryBtn";

const BookYourTickets = () => {
  return (
    <div
      className="h-[544px] max-md:h-[500px] max-sm:h-[350px] max-w-full bg-cover bg-center max-sm:bg-left"
      style={{
        backgroundImage: `url(${BookYourFlightsImage})`,
      }}
    >
      <div className="container 2xl:max-w-[1240px] px-5 xl:px-10 mx-auto pt-[204px] pb-[205px] max-sm:py-[120px]">
        <Title
          text={"Book Your Tickets"}
          myClass={"!text-white pb-7 max-md:pb-5 max-md:text-center"}
        />
        <div className="max-sm:flex max-sm:justify-center">
          <PrimaryBtn
            text={"Book Now"}
            myClass={
              "!px-5 !text-black !py-[10px] max-lg:!py-2 !bg-white border-white hover:border-[#FF5858] "
            }
            spanClass="!text-black group-hover:text-white"
            secondSpanClass="!bg-[#FF5858] border-white"
          />
        </div>
      </div>
    </div>
  );
};

export default BookYourTickets;
